import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectLanguageConfigComponent } from './select-language-config.component';
import { FormsModule } from '@angular/forms';
// import { NgZorroAntModule } from 'src/app/ng-zorro-ant.module';
// import { VhStringPercentPipeModule } from 'vhobjects-config';
import { TranslateModule } from '@ngx-translate/core';
import { NgZorroAntModule, VhStringPercentPipeModule } from 'vhobjects-service';
@NgModule({
  declarations: [
    SelectLanguageConfigComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgZorroAntModule,
    VhStringPercentPipeModule,
    TranslateModule
  ],
  exports: [
    SelectLanguageConfigComponent
  ]
})
export class SelectLanguageConfigModule { }
